import Reveal from "@/components/base/Reveal";
import { transferSteps } from "@/mocks/home";

export default function TransferPath() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-content px-5 py-16 md:px-6 md:py-20">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-600">
            Transfer Path
          </p>
          <h2 className="mt-3 font-heading text-[26px] font-bold tracking-tight text-foreground-950 md:text-[34px]">
            コミカレから4年制大学への流れ
          </h2>
          <p className="mt-4 text-[13px] leading-[1.95] text-foreground-600 md:text-[14px]">
            一般的な編入までのステップです。順番と必要な準備を押さえておくと、計画が立てやすくなります。英語試験やビザ、TSIA2の時期は学校や個人の条件で異なるため、必ずこの順番で進める必要はありません。
          </p>
        </Reveal>

        <ol className="mt-11 grid gap-5 sm:grid-cols-2 md:gap-6 lg:grid-cols-4">
          {transferSteps.map((item, index) => (
            <Reveal
              key={item.id}
              as="li"
              delay={index * 70}
              className="relative h-full rounded-[10px] border border-background-200 bg-background-50 p-6"
            >
              <span className="inline-flex h-9 items-center justify-center rounded-full bg-primary-100 px-3.5 font-heading text-[12px] font-bold tracking-[0.08em] text-primary-800">
                STEP {item.step}
              </span>
              <h3 className="mt-5 font-heading text-[16px] font-bold leading-[1.6] text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2.5 text-[12.5px] leading-[1.9] text-foreground-600">
                {item.description}
              </p>
            </Reveal>
          ))}
        </ol>

        <p className="mt-8 flex items-start justify-center gap-2 text-center text-[12px] leading-[1.9] text-foreground-500">
          <i className="ri-information-line mt-0.5 text-[14px] text-primary-600" />
          編入の条件や必要単位数は大学ごとに異なります。詳しくは各大学の公式情報を確認してください。
        </p>
      </div>
    </section>
  );
}